import GenerarNotasCreditoPage from "./GenerarNotasCreditoPage";

export {GenerarNotasCreditoPage}
export default GenerarNotasCreditoPage
